// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"530":"page","820":"serviceList","945":"dashboard"}[chunkId] || chunkId) + "." + {"91":"2da5dfc4","530":"399e42cd","820":"450d2af9","945":"00df3329"}[chunkId] + ".css";
};